var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function Svg4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M48.7574 0H11.2427C5.05684 0 0 5.05684 0 11.2427V48.7338C0 54.9432 5.05684 59.9765 11.2427 59.9765H48.7338C54.9432 59.9765 59.9765 54.9196 59.9765 48.7338V11.2427C60 5.05684 54.9667 0 48.7574 0ZM57.5069 48.7574C57.5069 53.579 53.579 57.5069 48.7574 57.5069H11.2427C6.42101 57.5069 2.49314 53.579 2.49314 48.7574V11.2427C2.49314 6.42101 6.42101 2.49314 11.2427 2.49314H48.7338C53.5555 2.49314 57.4833 6.42101 57.4833 11.2427V48.7574H57.5069ZM36.8326 14.3238L15.0529 36.1035C13.4065 37.7499 12.4892 39.9608 12.4892 42.2893V46.2642C12.4892 46.9463 13.0537 47.5108 13.7358 47.5108H17.7107C20.0157 47.5108 22.2736 46.57 23.8965 44.9471L45.6762 23.1674C48.1223 20.7213 48.1223 16.7699 45.6762 14.3238C43.3242 11.9718 39.1846 11.9718 36.8326 14.3238ZM22.1325 43.1595C20.98 44.3356 19.3571 44.9941 17.7107 44.9941H15.0059V42.2893C15.0059 40.6194 15.6644 39.0435 16.8405 37.8675L33.3516 21.3563L38.6437 26.6484L22.1325 43.1595ZM43.9122 21.4034L40.4312 24.8844L35.1392 19.5923L38.6201 16.1113C40.0314 14.7001 42.501 14.7001 43.9122 16.1113C45.3704 17.5696 45.3704 19.9451 43.9122 21.4034Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg4);
export default __webpack_public_path__ + "static/media/4.5a694d5852b09b7d0d1f2e9d5905cccd.svg";
export { ForwardRef as ReactComponent };